import React from 'react';
import { EdgeLabelRenderer, BaseEdge, getSmoothStepPath } from '@xyflow/react';
import IconNotebook from './IconNotebook';


// Helper component to render the edge label
function EdgeLabelStatus({ transform, label, url }) {

  const handleRedirect = () => {
    window.open(url, '_blank'); 
  };

  return (
    <div
      style={{
        position: 'absolute',
        background: 'transparent',
        padding: '5px 0px',
        color: label === "success" ? "#24A148" : "#F0BF0F",
        fontSize: "10px",
        fontFamily: "Poppins",
        fontWeight: 500,
        transform,
        display: "flex",
        alignItems: "center"
      }}
    >
      <div style={{padding: "2px", cursor: "pointer", fontSize: "14px"}} onClick={handleRedirect}>
        <IconNotebook />
      </div>
      <div>
        {label === "success" ? "Successful Integration" : "Delayed Integration"}
      </div>
    </div>
  );
}

function EdgeLabel({ transform, label }) {
  return (
    <div
      style={{
        position: 'absolute',
        background: 'transparent',
        padding: 10,
        color: '#929497',
        fontFamily: "Poppins",
        fontSize: "10px",
        fontWeight: 400,
        transform,
      }}
    >
      {label}
    </div>
  );
}

function EdgeLabelTimeStamp({ transform, label }) {
  return (
    <div
      style={{
        position: 'absolute',
        background: 'transparent',
        padding: 10,
        color: '#333333',
        fontFamily: "Poppins",
        fontSize: 10,
        fontWeight: 500,
        transform,
      }}
    >
      {label}
    </div>
  );
}

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) => {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        stepSize: 50, // You can adjust the step size for the smoothness of the path
      });

  return (
    <>

      <BaseEdge id={id} path={edgePath} markerEnd={'url(#customArrow)'}/>
      <EdgeLabelRenderer>
        {data.status && (
          <div>
            <EdgeLabelStatus
              transform={`translate(-100%, -200%) translate(${targetX}px,${targetY}px)`}
              label={data.status}
              url={data.url}
            />
            <EdgeLabel
              transform={`translate(-100%, -150%) translate(${targetX}px,${targetY}px)`}
              label="Output used"
            />
             <EdgeLabelTimeStamp
              transform={`translate(-100%, -100%) translate(${targetX}px,${targetY}px)`}
              label={data.timeStamp}
            />
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
